/* global Masonry, jQuery, $, sQuery */
/* eslint no-unused-vars: 0 */
if (window.innerWidth > 767 && jQuery('.articles .row').length) {
  const msnry = new Masonry('.articles .row', {
    itemSelector: '.col-sm-6',
  });
}

// (function($) {
//   $(document).on('sf:ajaxfinish', '.searchandfilter', () => {
//     console.log('ajax stopped begin');
//     $('body')
//       .find('.articles .row')
//       .masonry({
//         itemSelector: '.col-sm-6',
//       });
//     console.log('ajax stopped end');
//   });
// })(jQuery);

if (window.sQuery) {
  window.sQuery(document).on('sf:ajaxfinish', '.searchandfilter', () => {
    console.log('ajax stopped begin');
    $('body')
      .find('.articles .row')
      .masonry({
        itemSelector: '.col-sm-6',
      });
    console.log('ajax stopped end');
  });
}
